/** @type {import('tailwindcss').Config} */
import config from './tailwind.config.mjs';

export default {
	...config,
	theme: {
		...config.theme,

		fontFamily: {
			...config.theme.fontFamily,

			freight: config.theme.fontFamily.sans,
			gotham: config.theme.fontFamily.serif,
			mona: config.theme.fontFamily.serif,
		}
	},
}
